// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
    background-color: #f0f2f5;
    overflow-x: hidden;
  }
  
  .container {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: start;
    padding: 40px;
  }
  
  .form-container {
    width: 100%;
    max-width: 100%;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 20px;
    overflow-y: auto;
    max-height: 70vh;
  }
  
  .form-title {
    text-align: center;
    font-size: 2em;
    margin-bottom: 10px;
    margin-bottom: 30px;
    color: #333;
  }
  
  .form-table {
    width: 90%;
    border-collapse: collapse;
  }
  
  .form-table td {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    vertical-align: top;
  }
  
  .form-table input,
  .form-table select,
  .form-table textarea {
    width: 100%;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
  
  .form-table textarea {
    resize: vertical;
    min-height: 60px;
  }
  
  .submit-button {
    background-color: #4caf50;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: block;
    margin: 20px auto;
  }
  
  .submit-button:hover {
    background-color: #45a049;
  }
  
  .text-center {
    text-align: center;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .form-title {
      font-size: 1.5em;
    }
  
    .form-container {
      padding: 15px;
      max-width: 100%;
    }
  
    .form-table td {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }
  
    .form-table td:before {
      content: attr(data-label);
      font-weight: bold;
      display: block;
      margin-bottom: 5px;
    }
  }
  
  @media (max-width: 480px) {
    .form-title {
      font-size: 1.2em;
    }
  
    .submit-button {
      width: 100%;
      padding: 10px;
    }
  }
  
/*body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Arial, sans-serif;
    background-color: #f0f2f5;
    overflow-x: hidden;
  }
  
  .container {
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: start;
    padding: 20px;
  }
  
  .form-container {
    width: 100%;
    max-width: 800px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 20px;
    overflow-y: auto;
    max-height: 90vh;
  }
  
  .form-title {
    text-align: center;
    font-size: 2em;
    margin-bottom: 20px;
    color: #333;
  }
  
  .form-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .form-table td {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    vertical-align: top;
  }
  
  .form-table input,
  .form-table select,
  .form-table textarea {
    width: 100%;
    padding: 8px;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-sizing: border-box;
  }
  
  .form-table textarea {
    resize: vertical;
    min-height: 60px;
  }
  
  .submit-button {
    background-color: #4caf50;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    display: block;
    margin: 20px auto;
  }
  
  .submit-button:hover {
    background-color: #45a049;
  }
  
  .text-center {
    text-align: center;
  }
  */`, "",{"version":3,"sources":["webpack://./src/pages/AddEmployee.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;;;IAGE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,eAAe;IACjB;;IAEA;MACE,cAAc;MACd,WAAW;MACX,sBAAsB;IACxB;;IAEA;MACE,yBAAyB;MACzB,iBAAiB;MACjB,cAAc;MACd,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,aAAa;IACf;EACF;;AAEF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAgFG","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n    font-family: Arial, sans-serif;\r\n    background-color: #f0f2f5;\r\n    overflow-x: hidden;\r\n  }\r\n  \r\n  .container {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: start;\r\n    padding: 40px;\r\n  }\r\n  \r\n  .form-container {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    background-color: #fff;\r\n    border-radius: 20px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    max-height: 70vh;\r\n  }\r\n  \r\n  .form-title {\r\n    text-align: center;\r\n    font-size: 2em;\r\n    margin-bottom: 10px;\r\n    margin-bottom: 30px;\r\n    color: #333;\r\n  }\r\n  \r\n  .form-table {\r\n    width: 90%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .form-table td {\r\n    padding: 10px;\r\n    border-bottom: 1px solid #ddd;\r\n    vertical-align: top;\r\n  }\r\n  \r\n  .form-table input,\r\n  .form-table select,\r\n  .form-table textarea {\r\n    width: 100%;\r\n    padding: 8px;\r\n    border-radius: 4px;\r\n    border: 1px solid #ccc;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .form-table textarea {\r\n    resize: vertical;\r\n    min-height: 60px;\r\n  }\r\n  \r\n  .submit-button {\r\n    background-color: #4caf50;\r\n    color: white;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    display: block;\r\n    margin: 20px auto;\r\n  }\r\n  \r\n  .submit-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .text-center {\r\n    text-align: center;\r\n  }\r\n  \r\n  /* Responsive Design */\r\n  @media (max-width: 768px) {\r\n    .form-title {\r\n      font-size: 1.5em;\r\n    }\r\n  \r\n    .form-container {\r\n      padding: 15px;\r\n      max-width: 100%;\r\n    }\r\n  \r\n    .form-table td {\r\n      display: block;\r\n      width: 100%;\r\n      box-sizing: border-box;\r\n    }\r\n  \r\n    .form-table td:before {\r\n      content: attr(data-label);\r\n      font-weight: bold;\r\n      display: block;\r\n      margin-bottom: 5px;\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .form-title {\r\n      font-size: 1.2em;\r\n    }\r\n  \r\n    .submit-button {\r\n      width: 100%;\r\n      padding: 10px;\r\n    }\r\n  }\r\n  \r\n/*body {\r\n    margin: 0;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n    font-family: Arial, sans-serif;\r\n    background-color: #f0f2f5;\r\n    overflow-x: hidden;\r\n  }\r\n  \r\n  .container {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: start;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .form-container {\r\n    width: 100%;\r\n    max-width: 800px;\r\n    background-color: #fff;\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    max-height: 90vh;\r\n  }\r\n  \r\n  .form-title {\r\n    text-align: center;\r\n    font-size: 2em;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n  }\r\n  \r\n  .form-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n  }\r\n  \r\n  .form-table td {\r\n    padding: 10px;\r\n    border-bottom: 1px solid #ddd;\r\n    vertical-align: top;\r\n  }\r\n  \r\n  .form-table input,\r\n  .form-table select,\r\n  .form-table textarea {\r\n    width: 100%;\r\n    padding: 8px;\r\n    border-radius: 4px;\r\n    border: 1px solid #ccc;\r\n    box-sizing: border-box;\r\n  }\r\n  \r\n  .form-table textarea {\r\n    resize: vertical;\r\n    min-height: 60px;\r\n  }\r\n  \r\n  .submit-button {\r\n    background-color: #4caf50;\r\n    color: white;\r\n    padding: 10px 20px;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n    display: block;\r\n    margin: 20px auto;\r\n  }\r\n  \r\n  .submit-button:hover {\r\n    background-color: #45a049;\r\n  }\r\n  \r\n  .text-center {\r\n    text-align: center;\r\n  }\r\n  */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
